import { TableHeaderType } from "../types/TableHeaderType";
export const VmComponentsHeader: TableHeaderType[] = [
       {
      label:'Name',
      key: 'name',
      id: 'name',
      sortable: true,
    },
    {
      id: 'componentType.name',
      label: 'Component Type',
      sortable: true,
      key: 'componentType.name',
    },
   
    {
      id: 'creationDate',
      label: 'Creation Date',
      sortable: true,
      key: 'creationDate',
    },
  ];